import { afterCadSymbolPlacement, cancelCadSymbolOp } from './afterCadSymbolPlacement';

export const CAD_PROJECT_PINS_SOURCE_ID = 'cad-project-pins';
/** Círculo de color (siempre visible; no depende de symbol placement). */
export const CAD_PROJECT_PINS_LAYER_ID = 'cad-project-pins-dots';
/** Badge con glifo (encima del círculo; si falla el symbol, el círculo sigue). */
export const CAD_PROJECT_PINS_ICON_LAYER_ID = 'cad-project-pins-icons';

export const CAD_PROJECT_PINS_LAYER_IDS = [
  CAD_PROJECT_PINS_LAYER_ID,
  CAD_PROJECT_PINS_ICON_LAYER_ID,
];

/**
 * CAD / imagen / labels se agregan al tope; los pines tienen que volver arriba.
 * Círculo se mueve ya; reintento tras placement por si un symbol (label/badge)
 * se agregó en el mismo frame.
 *
 * @param {object} map
 */
export function moveCadProjectPinsForeground(map) {
  if (!map || typeof map.getLayer !== 'function') return;
  const move = () => {
    CAD_PROJECT_PINS_LAYER_IDS.forEach((layerId) => {
      try {
        if (map.getLayer(layerId)) map.moveLayer(layerId);
      } catch (_) { /* estilo a medias */ }
    });
  };
  move();
  afterCadSymbolPlacement(move);
}

/**
 * @param {object} map
 * @param {{ x: number, y: number }} point
 * @returns {object|null}
 */
export function queryCadProjectPinAtPoint(map, point) {
  if (!map || !point || typeof map.getLayer !== 'function') return null;
  const layers = CAD_PROJECT_PINS_LAYER_IDS.filter((id) => {
    try { return Boolean(map.getLayer(id)); } catch (_) { return false; }
  });
  if (!layers.length) return null;
  try {
    const hits = map.queryRenderedFeatures(point, { layers });
    return hits[0] || null;
  } catch (_) {
    return null;
  }
}

/**
 * @param {object} map
 */
export function removeCadProjectPinLayers(map) {
  if (!map) return;
  cancelCadSymbolOp(CAD_PROJECT_PINS_ICON_LAYER_ID);
  CAD_PROJECT_PINS_LAYER_IDS.forEach((layerId) => {
    try {
      if (map.getLayer(layerId)) map.removeLayer(layerId);
    } catch (_) { /* noop */ }
  });
  try {
    if (map.getSource(CAD_PROJECT_PINS_SOURCE_ID)) map.removeSource(CAD_PROJECT_PINS_SOURCE_ID);
  } catch (_) { /* noop */ }
}
